import { render, staticRenderFns } from "./InPlaceDialog.vue?vue&type=template&id=05dde7ab&scoped=true&"
import script from "./InPlaceDialog.vue?vue&type=script&lang=js&"
export * from "./InPlaceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dde7ab",
  null
  
)

export default component.exports